import BusinessDetailsSubHeader from './BusinessDetailsSubHeader'

export default BusinessDetailsSubHeader
